<nz-card *ngIf="!eventFormVisible" style="min-height: 400px">
  <div nz-row></div>
  <div class="row m-b-30 d">
    <div class="col-lg-7">
      <div class="d-md-flex">
        <div class="m-b-10 m-r-20">
          <nz-input-group [nzPrefix]="prefixTemplate" [nzSuffix]="suffixTemplate">
            <input
              type="text"
              nz-input
              placeholder="Search"
              (keyup)="onKeyUp(searchBox.value)"
              [(ngModel)]="searchTerm"
              #searchBox
            />
          </nz-input-group>
          <ng-template #suffixTemplate>
            <a nz-icon class="opacity-05" (click)="resetSearch()">
              <i nz-icon nzType="close" class="opacity-05"></i>
            </a>
          </ng-template>
          <ng-template #prefixTemplate>
            <i nz-icon nzType="search" class="opacity-05"></i>
          </ng-template>
        </div>
        <div class="m-b-10 m-r-10">
          <button
              nz-button
              nz-popover
              [nzPopoverContent]="popoverContent"
              nzPopoverTrigger="click"
              nzPopoverPlacement="bottom"
              [(nzPopoverVisible)]="filterVisible"
              (nzPopoverVisibleChange)="onPopoverVisibleChange($event)"
              class="btn-outline resource-btn"
              style="text-align: center"
            >
            All Events<i
              nz-icon
              nzType="caret-down"
              style="position: relative; top: 1px; left: -3px"
              nzTheme="outline"
            ></i>
          </button>
          <ng-template
            class="filter"
            style="width: 50px; text-align: left; padding: 0px !important"
            #popoverContent
          >
            <div class="" style="width: 180px !important">
              <div nz-row nzGutter="24">
                <div
                  nz-col
                  class="gutter-row"
                  nzSpan="24"
                  style="padding-bottom: 15px"
                >
                  <span class="filter-heading">Show Events that are</span>
                </div>
              </div>
            </div>

            <div style="width: 100%; height: 80px" nz-row>
              <div
                style="color: #2d2d35; font-family: Poppins !important"
                nz-col
                nzSpan="24"
              >
                <!-- <label nz-checkbox [(ngModel)]="isUsedInLast30Days"
                  >Used in last 30 days</label
                >
                <nz-divider
                  style="
                    margin-top: 5px !important;
                    margin-bottom: 10px !important;
                  "
                ></nz-divider> -->
                <label nz-checkbox [(ngModel)]="active">Active</label>
                <nz-divider
                  style="
                    margin-top: 5px !important;
                    margin-bottom: 10px !important;
                  "
                ></nz-divider>
                <label nz-checkbox [(ngModel)]="archived">Archived</label>
              </div>
            </div>
            <div nz-row>
              <div
                nz-col
                nzSpan="24"
                class="d-flex align-items-center justify-content-between"
              >
                <span (click)="clickFilter()" class="cancel-label">Cancel</span>

                <button
                  class="btn-fill"
                  nz-button
                  nzType="default"
                  nzSize="small"
                  (click)="filterEventData()"
                >
                  Apply
                </button>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="col-lg-5">
      <div class="d-md-flex justify-content-end">
        <!-- <div class="m-b-10 m-r-10">
          <nz-radio-group class="m-r-10">
            <label
              nz-radio-button
              nzValue="mailView"
              nzTooltipTitle="Mail View"
              nzTooltipPlacement="bottom"
              nz-tooltip
            >
              <i class="font-size-16" nz-icon nzType="mail" theme="fill"></i>
            </label>
            <label
              nz-radio-button
              nzValue="excelView"
              nzTooltipTitle="Excel View"
              nzTooltipPlacement="bottom"
              nz-tooltip
            >
              <i
                class="font-size-16"
                nz-icon
                nzType="file-excel"
                theme="fill"
              ></i>
            </label>
            <label
              nz-radio-button
              nzValue="printView"
              nzTooltipTitle="Print View"
              nzTooltipPlacement="bottom"
              nz-tooltip
            >
              <i class="font-size-16" nz-icon nzType="printer" theme="fill"></i>
            </label>
          </nz-radio-group>
        </div> -->
        <!-- <div class="m-b-10 m-r-20">
          <nz-radio-group>
            <label
              nz-radio-button
              nzValue="cardView"
              nzTooltipTitle="Card View"
              nzTooltipPlacement="bottom"
              nz-tooltip
            >
              <i
                class="font-size-16"
                nz-icon
                nzType="appstore"
                theme="fill"
              ></i>
            </label>
          </nz-radio-group>
        </div> -->
        <button
          nz-button=""
          nztype=" primary"
          class="font-small-caps btn-custom-light"
          title="Delete"
          *ngIf="anyChecked"
          nz-wave="[object Object]"
          [nzLoading]="isLoading"
          nz-popconfirm
          nzPopconfirmTitle="Are you sure you want to delete the selected events?"
          (nzOnConfirm)="deleteEvent(null, true)"
          nzPopconfirmPlacement="topRight"
          style="margin-right: 10px"
        >
          <i class="font-size-16" nz-icon nzType="delete" theme="fill"></i>
        </button>
        <button
          nz-button
          nzType="default"
          class="btn-fill"
          (click)="openEventForm()"
        >
          <span
            ><i
              class="fa fa-plus button-plus-icon"
              aria-hidden="true"
            ></i></span
          >&nbsp;NEW
        </button>
      </div>
    </div>
  </div>

  <div nz-row nzGutter="16">
    <div nz-col class="gutter-row" nzSpan="24">
      <nz-table
        #eventGroupTable
        [nzData]="eventData"
        [nzPageSize]="20"
        [nzLoading]="showLoad"
      >
        <thead nzSingleSort>
          <tr>
            <th
              nzShowCheckbox
              [(nzChecked)]="allChecked"
              (nzCheckedChange)="checkAll($event)"
            ></th>
            <ng-container *ngFor="let column of listOfColumns">
              <th
                *ngIf="column.name !== ''"
                [nzSortOrder]="column.sortOrder"
                [nzSortFn]="column.sortFn"
                [nzSortDirections]="column.sortDirections"
                [nzFilterMultiple]="column.filterMultiple"
                [nzWidth]="column.colWidth"
              >
                {{ column.name }}
              </th>
              <th *ngIf="column.name === ''">{{ column.name }}</th>
            </ng-container>
            <!-- <th
              *ngFor="let column of listOfColumns"
              [nzSortOrder]="column.sortOrder"
              [nzSortFn]="column.sortFn"
              [nzSortDirections]="column.sortDirections"
            >
              {{ column.name }}
            </th> -->
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let data of eventGroupTable.data"
            class="data-row cursor-move"
          >
            <!-- {{data | json}} -->
            <td
              nzShowCheckbox
              [(nzChecked)]="data.checked"
              (nzCheckedChange)="refreshStatus()"
            ></td>

            <td>
              <div class="d-flex align-items-center">
                <span class="m-b-0">{{ data.event_name }}</span>
              </div>
            </td>
            <td>
              {{ data.start_date | date : "MM/dd/yyyy" }}
            </td>
            <td>{{ data.end_date | date : "MM/dd/yyyy" }}</td>
            <td>{{ data.lead_form_name }}</td>
            <td>{{ getEmailNamesWithCount(data.emailNames) }}</td>
            <!-- <td>{{ data.emailNames }}</td> -->
            <td>{{ data.access_group_name }}</td>

            <td>
              <!-- <span class="data-row-action"> -->
                <span class="">
                <nz-switch
                  [(ngModel)]="data.is_active"
                  [nzControl]="true"
                  (click)="clickSwitch(data)"
                  [nzLoading]="loadingSwitch"
                  nzSize="small"
                ></nz-switch>
              </span>
            </td>

            <td>
              <!-- <span class="data-row-action"> -->
                <span class="">
                <a
                  class="m-r-5"
                  nz-button
                  nzType="default"
                  nzShape="circle"
                  nz-tooltip
                  nzTooltipTitle="Edit"
                >
                  <i
                    nz-icon
                    nzType="edit"
                    theme="outline"
                    (click)="fillEventForm(data)"
                  ></i>
                </a>
                <button
                  nz-button
                  nzType="default"
                  nzShape="circle"
                  nz-tooltip
                  nzTooltipTitle="Delete"
                >
                  <i
                    nz-icon
                    nzType="delete"
                    theme="outline"
                    nz-popconfirm
                    nzPopconfirmTitle="Are you sure you want to delete this event?"
                    (nzOnConfirm)="deleteEvent(data.id)"
                  ></i>
                </button>
              </span>
            </td>

            <!-- <td>
              <span class="data-row-action">
                <nz-switch
                  [(ngModel)]="data.is_active"
                  [nzControl]="true"
                  [nzLoading]="loadingSwitch"
                  nzSize="small"
                  (click)="clickSwitch(data)"
                ></nz-switch>

                <i
                  nz-icon
                  nzType="edit"
                  nzTheme="outline"
                  (click)="fillEventForm(data)"
                  class="m-r-15"
                ></i>
                <i
                  nz-icon
                  nzType="delete"
                  theme="outline"
                  [nzLoading]="isLoading"
                  nz-popconfirm
                  nzPopconfirmTitle="Are you sure you want to delete this event?"
                  (nzOnConfirm)="deleteEvent(data.id)"
                ></i>
              </span>
            </td> -->
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</nz-card>
<nz-card *ngIf="eventFormVisible">
  <div nz-row nzGutter="16">
    <div
      nz-col
      class="gutter-row"
      nzSpan="24"
      style="text-align: right; width: 100%; height: 20px"
    >
      <a
        title="Cancel"
        (click)="this.checkFormState()"
        style="float: right; margin-bottom: 20px"
        ><i nz-icon nzType="close" theme="outline"></i
      ></a>
    </div>
  </div>
  <div class="form-container" [class.disabled]="isLoading">
  <form nz-form nzLayout="vertical" [formGroup]="eventForm"  >
    <div nz-row>
      <div nz-col nzSpan="6">
        <nz-form-item>
          <nz-form-label nzRequired>Event</nz-form-label>
          <nz-form-control
            _ngcontent-jfp-c14=""
            class="ng-tns-c16-67 ant-form-item-control-wrapper ng-star-inserted ant-col-24"
          >
            <div class="ant-form-item-control">
              <span class="ant-form-item-children">
                <input
                  _ngcontent-jfp-c14=""
                  nz-input=""
                  formControlName="event_name"
                  placeholder="Event Name"
                  nzSize="medium"
                  class="ant-input ng-untouched ng-pristine ng-invalid" /><span
                  class="ant-form-item-children-icon"
                >
                </span
              ></span>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="1">&nbsp;</div>
      <div nz-col nzSpan="8" class="d-flex justify-content-between">
        <div style="display: inline-flex; align-items: flex-start">
          <nz-form-item>
            <nz-form-label nzRequired>Start Date</nz-form-label>
            <nz-form-control>
              <nz-date-picker
                [(ngModel)]="startValue"
                (nzOnOpenChange)="handleStartOpenChange($event)"
                [nzDisabledDate]="disabledStartDate"
                nzFormat="MM-dd-yyy"
                nzShowToday="false"
                formControlName="start_date"
              ></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div style="display: inline-flex; align-items: flex-end">
          <nz-form-item>
            <nz-form-label nzRequired>End Date</nz-form-label>
            <nz-form-control>
              <nz-date-picker
                #endDatePicker
                [(ngModel)]="endValue"
                [nzDisabledDate]="disabledEndDate"
                (nzOnOpenChange)="handleEndOpenChange($event)"
                nzShowToday="false"
                nzFormat="MM-dd-yyy"
                formControlName="end_date"
              ></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-col nzSpan="1">&nbsp;</div>

      <!-- <div nz-col>
        <nz-form-item>
          <nz-form-label></nz-form-label>
          <nz-form-control
            ><label
              nz-checkbox
              style="font-size: 11px; color: #545461; font-weight: 400"
              >Archive Event and event data after end date</label
            ></nz-form-control
          >
        </nz-form-item>
      </div> -->
    </div>

    <div nz-row>
      <div nz-col nzSpan="6">
        <nz-form-item>
          <nz-form-label nzRequired>Lead form</nz-form-label>
          <nz-form-control>
            <div>
              <span>
                <nz-select
                  formControlName="lead_form_id"
                  nzShowSearch
                  nzAllowClear
                  nzPlaceHolder="Select Lead"
                  nzTitle="Select Lead"
                  style="width: 100%"
                  [nzCustomTemplate]="selectedLeadTemplate"
                >
                  <nz-option
                    nzCustomContent
                    *ngFor="let item of leadList"
                    [nzLabel]="item.name"
                    [nzValue]="item.lead_form_id"
                  >
                    <nz-avatar
                      [ngStyle]="{ 'background-color': item.colorCode }"
                      [nzText]="item.text"
                      style="
                        font-family: Poppins !important;
                        margin-right: 10px;
                      "
                      nzSize="small"
                    ></nz-avatar
                    >{{ item.name }}</nz-option
                  >

                  <ng-template #selectedLeadTemplate let-selectedl>
                    <span>
                      <nz-avatar
                        [ngStyle]="{
                          'background-color': selectedl.nzValue.colorCode
                        }"
                        [nzText]="selectedl.nzValue.text"
                        style="
                          font-family: Poppins !important;
                          margin-right: 10px;
                        "
                        nzSize="small"
                      ></nz-avatar>
                      {{ selectedl.nzLabel }}
                    </span>
                  </ng-template>
                </nz-select>
                <span></span>
              </span>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="1">&nbsp;</div>

      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label nzRequired>Send Leads to</nz-form-label>
          <nz-form-control>
            <div>
              <span>
                <nz-select
                  nzShowSearch
                  nzAllowClear
                  class="ant-col-30 m-r-10"
                  nzMode="multiple"
                  [(ngModel)]="selectedEventLeads"
                  [ngModelOptions]="{ standalone: true }"
                  nzPlaceHolder="Add-on Belongs To"
                  nzTitle="Select Event Leads"
                >
                  <nz-option
                    *ngFor="let item of eventLeadList"
                    [nzValue]="item.event_lead_id"
                    [nzLabel]="item.email"
                  >
                  </nz-option>
                </nz-select>
                <span> </span>
              </span>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSpan="1">&nbsp;</div>

      <div nz-col nzSpan="6">
        <nz-form-item>
          <nz-form-label nzRequired>Attract Loop</nz-form-label>
          <nz-form-control>
            <div>
              <span>
                <nz-select
                  formControlName="attract_loop_id"
                  nzShowSearch
                  nzAllowClear
                  class="ant-col-30 m-r-10"
                  nzPlaceHolder="Select Attract Loop"
                  nzTitle="Select Attract Loop"
                  [nzCustomTemplate]="selectedTemplate"
                >
                  <nz-option
                    nzCustomContent
                    *ngFor="let item of attractLoopList"
                    [nzLabel]="item.name"
                    [nzValue]="item.attract_loop_id"
                  >
                    <nz-avatar
                      [ngStyle]="{ 'background-color': item.colorCode }"
                      [nzText]="item.text"
                      style="
                        font-family: Poppins !important;
                        margin-right: 10px;
                      "
                      nzSize="small"
                    ></nz-avatar
                    >{{ item.name }}</nz-option
                  >

                  <ng-template #selectedTemplate let-selected>
                    <span>
                      <nz-avatar
                        [ngStyle]="{
                          'background-color': selected.nzValue.colorCode
                        }"
                        [nzText]="selected.nzValue.text"
                        style="
                          font-family: Poppins !important;
                          margin-right: 10px;
                        "
                        nzSize="small"
                      ></nz-avatar>
                      {{ selected.nzLabel }}
                    </span>
                  </ng-template>
                </nz-select>
                <span> </span>
              </span>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row>
      <div nz-col nzSpan="6">
        <nz-form-item>
          <nz-form-label>Group</nz-form-label>
          <nz-form-control>
            <div>
              <span>
                <nz-select
                  formControlName="access_group_id"
                  name="Group"
                  nzPlaceHolder="Please select"
                  nzSize="small"
                >
                  <nz-option
                    *ngFor="let item of groupList"
                    [nzLabel]="item.access_group_name"
                    [nzValue]="item.access_group_id"
                  ></nz-option>
                </nz-select>
                <ng-template #selectedGroupTemplate let-selectedg>
                  <span>
                    <nz-avatar
                      [nzSize]="30"
                      nzIcon="user"
                      [nzSrc]="selectedg.nzValue.avatar"
                      style="margin-right: 10px"
                    ></nz-avatar>
                    {{ selectedg.nzLabel }}
                  </span>
                </ng-template>
                <span> </span>
              </span>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row nzGutter="16">
      <div nz-col nzSpan="12">
        <button
          *ngIf="!updateMode"
          _ngcontent-jfp-c14=""
          (click)="resetEventForm()"
          nz-button=""
          nztype="default"
          class="ant-btn ant-btn-default"
          nz-wave="[object Object]"
        >
          <!----><span>Reset</span>
        </button>
        <button
          *ngIf="updateMode"
          _ngcontent-jfp-c14=""
          (click)="resetUpdateForm()"
          nz-button=""
          nztype="default"
          class="ant-btn ant-btn-default"
          nz-wave="[object Object]"
        >
          <!----><span>Reset</span>
        </button>
      </div>
      <div nz-col class="gutter-row" nzSpan="12" style="text-align: right">
        <button
          nz-button=""
          nztype="default"
          class="cancelbtn-outline"
          style="padding-left: 25px; padding-right: 25px; margin-right: 10px"
          (click)="this.checkFormState()"
        >
          <span>Cancel</span>
        </button>
        <!-- <span class="cancel-label m-r-20" (click)="checkFormState()"
          >Cancel</span
        > -->
        <!-- (click)="closeEventForm()" -->
        <button
          _ngcontent-jfp-c14=""
          nz-button=""
          nztype="default"
          class="ant-btn ant-btn-primary"
          *ngIf="!updateMode"
          nz-wave="[object Object]"
          style="padding-left: 25px; padding-right: 25px"
          [nzLoading]="isLoading"
          (click)="submitEvent()"
          [disabled]="
            !this.eventForm.valid || this.selectedEventLeads.length === 0
          "
        >
          <!----><span>Save</span>
        </button>
        <button
          _ngcontent-jfp-c14=""
          nz-button=""
          nztype="default"
          class="ant-btn ant-btn-primary"
          *ngIf="updateMode"
          nz-wave="[object Object]"
          [nzLoading]="isLoading"
          (click)="updateEvent()"
          [disabled]="!eventForm.dirty"
        >
          <!----><span>Update</span>
        </button>
      </div>
    </div>
  </form>

     <!-- Loading overlay -->
     <div class="overlay" *ngIf="isLoading"></div>
  </div>
</nz-card>
